import axios from "axios";
import { toast } from "react-toastify";
import storage from "../utils/storage";

/**
 * Tek HTTP istemcisi.
 *
 * Tüm feature repository'leri (`features/<x>/api/repository.js`) bu instance'ı
 * kullanmalıdır. Component'ler axios'u doğrudan import etmemeli (ESLint
 * `no-restricted-imports` warn şu an, Faz 11'de error olacak).
 *
 * Sözleşme:
 *   - baseURL:   import.meta.env.VITE_API_URL veya `${PUBLIC_URL}/api` (mock)
 *   - timeout:   15s
 *   - request:   AuthAdapter token (Faz 6'da entegre edilecek)
 *   - response:  401 → auth.signOut(); 5xx → tek toast
 *   - signal:    her sorgu AbortController desteği taşımak için ekstra arg geçer
 */

const baseURL =
  import.meta.env.VITE_API_URL || `${"" || ""}/api`;

const http = axios.create({
  baseURL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor — token ekle (Faz 6'da AuthAdapter'a bağlanacak)
http.interceptors.request.use((config) => {
  const token = storage.get("auth_token");
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — hata normalize + auth/network feedback
http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url ?? "";

    if (status === 401) {
      // Faz 6: auth.signOut() çağrılacak; şimdilik storage temizliği
      storage.remove("auth_token");
      storage.theme.setAuthenticated(false);
      window.location.href = `${"" || ""}/login`;
      return Promise.reject(error);
    }

    if (status >= 500) {
      toast.error(`Sunucu hatası (${status}). Lütfen daha sonra tekrar deneyin.`);
    } else if (!error.response) {
      // network/timeout
      if (error.code !== "ERR_CANCELED") {
        toast.error("Ağ hatası — bağlantınızı kontrol edin.");
      }
    }

    // Geliştirme uyarısı
    if (import.meta.env.MODE !== "production") {
       
      console.warn(`[http] ${error.config?.method?.toUpperCase()} ${url} → ${status}`);
    }

    return Promise.reject(error);
  }
);

export default http;
